const ActivityType = Object.freeze({
    Basic: 'basic',
    Card: 'card',
    Activity: 'activity',
});

export default ActivityType;
